"use strict";

require("core-js/modules/es.weak-map.js");

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.object.assign.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.promise.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/typeof"));

require("antd/lib/form/style");

var _form = _interopRequireDefault(require("antd/lib/form"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

require("antd/lib/typography/style");

var _typography = _interopRequireDefault(require("antd/lib/typography"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

require("./WizardForm.less");

var _react = _interopRequireWildcard(require("react"));

var _Wizard = _interopRequireDefault(require("./Wizard"));

var _excluded = ["autoFocusFirstInput", "children", "activeKey", "doneButtonText", "form", "formProps", "stepsProps", "nextButtonDisabled", "clickableSteps", "saveMode", "onFinish", "onStepChange", "onStepChanging", "onStepError", "onStepErrorInsist", "onSubmit", "onCancel", "loading", "nextButtonLoading", "doneButtonProps", "nextButtonProps", "footerExtra", "enableAutocompletePassword"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function focusFirstInput(container) {
  if (container) {
    var firstInput = container.querySelector('input');

    if (firstInput) {
      //need to wait for possible animation to focus
      setTimeout(function () {
        firstInput.focus();
      }, 200);
    }
  }
}

var _default = WizardForm;
/**
 * @desc Enhances Wizard functionality and validates your fields on each step
 */

exports.default = _default;

function WizardForm(_ref) {
  var autoFocusFirstInput = _ref.autoFocusFirstInput,
      children = _ref.children,
      activeKey = _ref.activeKey,
      doneButtonText = _ref.doneButtonText,
      form = _ref.form,
      formProps = _ref.formProps,
      stepsProps = _ref.stepsProps,
      nextButtonDisabled = _ref.nextButtonDisabled,
      clickableSteps = _ref.clickableSteps,
      saveMode = _ref.saveMode,
      onFinish = _ref.onFinish,
      onStepChange = _ref.onStepChange,
      onStepChanging = _ref.onStepChanging,
      onStepError = _ref.onStepError,
      onStepErrorInsist = _ref.onStepErrorInsist,
      onSubmit = _ref.onSubmit,
      onCancel = _ref.onCancel,
      loading = _ref.loading,
      nextButtonLoading = _ref.nextButtonLoading,
      doneButtonProps = _ref.doneButtonProps,
      nextButtonProps = _ref.nextButtonProps,
      footerExtra = _ref.footerExtra,
      enableAutocompletePassword = _ref.enableAutocompletePassword,
      rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);

  if (children === undefined) {
    throw new Error('WizardForm must have at least 1 step/children (WizardForm.Step)');
  }

  var steps = (children.length === undefined ? [children] : children).filter(function (c) {
    return c !== null;
  });
  var wizRef = (0, _react.useRef)();

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      errorMessage = _useState2[0],
      setErrorMessage = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      currentError = _useState4[0],
      setCurrentError = _useState4[1];

  var _useState5 = (0, _react.useState)(steps.map(function () {
    return false;
  })),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      touched = _useState6[0],
      setTouched = _useState6[1];

  var _useState7 = (0, _react.useState)(activeKey),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      selectedKey = _useState8[0],
      setSelectedKey = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      validationLoading = _useState10[0],
      setValidationLoading = _useState10[1];

  (0, _react.useEffect)(function () {
    if (autoFocusFirstInput) {
      if (wizRef.current) {
        focusFirstInput(wizRef.current.getCurrentStepRef());
      }
    }
  }, []);
  (0, _react.useEffect)(function () {
    setSelectedKey(activeKey);
  }, [activeKey]);
  /**
   * Executes functions to validate and throws error when functions return false
   * or throws error.
   * @param functionsToValidate
   */

  function validateFunctions(_x) {
    return _validateFunctions.apply(this, arguments);
  }
  /**
   * Separates validation array in 2 arrays: fields to validate, and functions
   * to validate.
   * @param validate
   * @returns {*[]}
   */


  function _validateFunctions() {
    _validateFunctions = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(functionsToValidate) {
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              setErrorMessage(null);
              setValidationLoading(true);
              _context4.prev = 2;
              _context4.next = 5;
              return Promise.all(functionsToValidate.map(function (f) {
                return f();
              }));

            case 5:
              setValidationLoading(false);
              _context4.next = 13;
              break;

            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](2);
              setErrorMessage(_context4.t0.message);
              setValidationLoading(false);
              throw _context4.t0;

            case 13:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[2, 8]]);
    }));
    return _validateFunctions.apply(this, arguments);
  }

  function getThingsToValidate(validate) {
    var validateArr = validate.call ? validate() : validate;
    return [validateArr.filter(function (v) {
      return typeof v === 'string' || v.length;
    }), validateArr.filter(function (v) {
      return !!v.call;
    })];
  }
  /**
   * Validates step by index
   * @param index
   * @returns {Promise<boolean>}
   */


  function validateStep(_x2) {
    return _validateStep.apply(this, arguments);
  }
  /**
   * Validates every step from one to another
   * @param stepIndexStart
   * @param stepIndexEnd
   * @param excludeIndex
   * @returns {Promise<boolean>}
   */


  function _validateStep() {
    _validateStep = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(index) {
      var _steps$index$props, validate, ignoreOutOfDateError, _getThingsToValidate, _getThingsToValidate2, fieldsToValidate, functionsToValidate, newTouched;

      return _regenerator.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _steps$index$props = steps[index].props, validate = _steps$index$props.validate, ignoreOutOfDateError = _steps$index$props.ignoreOutOfDateError;

              if (!validate) {
                _context5.next = 27;
                break;
              }

              _getThingsToValidate = getThingsToValidate(validate), _getThingsToValidate2 = (0, _slicedToArray2.default)(_getThingsToValidate, 2), fieldsToValidate = _getThingsToValidate2[0], functionsToValidate = _getThingsToValidate2[1];
              _context5.prev = 3;
              _context5.next = 6;
              return form.validateFields(fieldsToValidate);

            case 6:
              _context5.next = 8;
              return validateFunctions(functionsToValidate);

            case 8:
              setCurrentError(null);
              return _context5.abrupt("return", true);

            case 12:
              _context5.prev = 12;
              _context5.t0 = _context5["catch"](3);

              if (!(ignoreOutOfDateError && (0, _typeof2.default)(_context5.t0) === 'object' && _context5.t0.errorFields && _context5.t0.errorFields.length === 0 && _context5.t0.outOfDate)) {
                _context5.next = 17;
                break;
              }

              setCurrentError(null);
              return _context5.abrupt("return", true);

            case 17:
              newTouched = (0, _toConsumableArray2.default)(touched);
              newTouched[index] = true;
              setTouched(newTouched);
              setSelectedKey(steps[index].key);
              setCurrentError(_context5.t0);

              if (currentError !== null && currentError.message === _context5.t0.message) {
                if (onStepErrorInsist) {
                  onStepErrorInsist(_context5.t0);
                }
              }

              if (onStepError) {
                onStepError(_context5.t0);
              }

              return _context5.abrupt("return", false);

            case 25:
              _context5.next = 28;
              break;

            case 27:
              return _context5.abrupt("return", true);

            case 28:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[3, 12]]);
    }));
    return _validateStep.apply(this, arguments);
  }

  var validateFromTo = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(stepIndexStart, stepIndexEnd) {
      var excludeIndex,
          invalidStepIndex,
          continues,
          i,
          _args = arguments;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              excludeIndex = _args.length > 2 && _args[2] !== undefined ? _args[2] : -1;
              invalidStepIndex = stepIndexStart;
              continues = true; // then we start to validate other steps

              i = 0;

            case 4:
              if (!(continues && i <= steps.length - 1)) {
                _context.next = 15;
                break;
              }

              invalidStepIndex = i;
              _context.t0 = i === excludeIndex;

              if (_context.t0) {
                _context.next = 11;
                break;
              }

              _context.next = 10;
              return validateStep(i);

            case 10:
              _context.t0 = _context.sent;

            case 11:
              continues = _context.t0;
              i++;
              _context.next = 4;
              break;

            case 15:
              if (continues) {
                _context.next = 21;
                break;
              }

              _context.next = 18;
              return validateStep(invalidStepIndex);

            case 18:
              return _context.abrupt("return", _context.sent);

            case 21:
              return _context.abrupt("return", true);

            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function validateFromTo(_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleStepChange = function handleStepChange(newStepIndex) {
    setErrorMessage(null);
    setSelectedKey(steps[newStepIndex].key);
    var newTouched = (0, _toConsumableArray2.default)(touched);
    newTouched[newStepIndex] = false;
    setTouched(newTouched);

    for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }

    onStepChange && onStepChange.apply(void 0, [newStepIndex].concat(rest));

    if (autoFocusFirstInput) {
      if (wizRef.current) {
        focusFirstInput(wizRef.current.getCurrentStepRef());
      }
    }
  };

  var handleStepChanging = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(newStepIndex, oldStepIndex) {
      var _len2,
          args,
          _key2,
          _args2 = arguments;

      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              for (_len2 = _args2.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
                args[_key2 - 2] = _args2[_key2];
              }

              onStepChanging && onStepChanging.apply(void 0, [newStepIndex, oldStepIndex].concat(args));

              if (!(!saveMode && newStepIndex < oldStepIndex)) {
                _context2.next = 4;
                break;
              }

              return _context2.abrupt("return", true);

            case 4:
              _context2.next = 6;
              return validateStep(oldStepIndex);

            case 6:
              return _context2.abrupt("return", _context2.sent);

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleStepChanging(_x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }();

  var handleFinish = /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(currentIndex) {
      var _len3,
          args,
          _key3,
          validationResult,
          _validationResult,
          _args3 = arguments;

      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              for (_len3 = _args3.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
                args[_key3 - 1] = _args3[_key3];
              }

              onFinish && onFinish.apply(void 0, [currentIndex].concat(args));

              if (saveMode) {
                _context3.next = 9;
                break;
              }

              _context3.next = 5;
              return validateStep(currentIndex);

            case 5:
              validationResult = _context3.sent;

              if (validationResult) {
                onSubmit && onSubmit();
              }

              _context3.next = 16;
              break;

            case 9:
              _context3.next = 11;
              return validateStep(currentIndex);

            case 11:
              if (!_context3.sent) {
                _context3.next = 16;
                break;
              }

              _context3.next = 14;
              return validateFromTo(0, steps.length - 1, currentIndex);

            case 14:
              _validationResult = _context3.sent;

              if (_validationResult) {
                onSubmit && onSubmit();
              }

            case 16:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleFinish(_x7) {
      return _ref4.apply(this, arguments);
    };
  }();

  var handleButtonBlur = function handleButtonBlur() {
    setErrorMessage(null);
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: 'WizardForm'
  }, /*#__PURE__*/_react.default.createElement(_form.default, Object.assign({
    form: form
  }, formProps), enableAutocompletePassword ? null :
  /*#__PURE__*/
  // hack so browser does not ask to save password
  _react.default.createElement("input", {
    type: "password",
    style: {
      display: 'none'
    }
  }), /*#__PURE__*/_react.default.createElement(_Wizard.default, Object.assign({
    ref: wizRef,
    activeKey: selectedKey,
    onStepChanging: handleStepChanging,
    onStepChange: handleStepChange,
    onFinish: handleFinish,
    onCancel: onCancel,
    footerExtra: /*#__PURE__*/_react.default.createElement("div", {
      className: 'WizardForm_footer'
    }, errorMessage ? /*#__PURE__*/_react.default.createElement(_typography.default.Text, {
      type: "danger"
    }, errorMessage) : footerExtra, /*#__PURE__*/_react.default.createElement("div", null)),
    doneButtonText: doneButtonText,
    doneButtonProps: (0, _objectSpread2.default)({
      onBlur: handleButtonBlur
    }, doneButtonProps),
    nextButtonProps: (0, _objectSpread2.default)({
      onBlur: handleButtonBlur
    }, nextButtonProps),
    nextButtonDisabled: nextButtonDisabled,
    clickableSteps: clickableSteps,
    saveMode: saveMode,
    loading: loading,
    nextButtonLoading: nextButtonLoading || validationLoading,
    stepsProps: stepsProps
  }, rest), steps)));
}

WizardForm.Step = function (_ref5) {
  var children = _ref5.children,
      footerExtra = _ref5.footerExtra,
      loading = _ref5.loading,
      nextButtonDisabled = _ref5.nextButtonDisabled,
      validate = _ref5.validate,
      _ref5$ignoreOutOfDate = _ref5.ignoreOutOfDateError,
      ignoreOutOfDateError = _ref5$ignoreOutOfDate === void 0 ? false : _ref5$ignoreOutOfDate;
  return /*#__PURE__*/_react.default.createElement(_Wizard.default.Step, {
    footerExtra: footerExtra,
    loading: loading,
    nextButtonDisabled: nextButtonDisabled,
    validate: validate,
    ignoreOutOfDateError: ignoreOutOfDateError
  }, children);
};